import { getSharedResources } from '../../queries';

const fetchSharedResources = async ({
  client,
  subjectId,
  classIds,
  educationPeriod,
}) => {
  const response = await client.query({
    query: getSharedResources,
    fetchPolicy: 'network-only',
    variables: {
      subjectId,
      classIds,
      educationPeriod,
    },
  });
  const { sharedVideoResources: resources } = (response && response.data) || {};
  return resources;
};

export default fetchSharedResources;
